<template>
	<div class="content">
		<div class="content_head">
			<p>
				<input type="text" @keypress="searchCustomers" placeholder="会员手机号|扫描会员二维码" class="search"
					v-model="searchText" />
				<button type="button" class="button" :disabled="searchText.length<=1"
					@click="getReturnBookByCustomerCode()" title="点击查找会员">查询会员</button>
			</p>
			<p>
				会员信息: <span v-if="customer!=null" class="red">
					{{ customer.CustomerName +' '+ customer.CustomerPhone }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					账号押金:{{customer.Deposit+'元' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					可借数量:{{customer.booksCount+'本' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					待还数量:{{customer.borrowBooksCount+'本' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					已借数量:{{customer.borrowBooksCount +'本'}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					再还数量:{{customer.returningCount+'本' }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					到期时间:{{ $moment (customer.VipEndDate).format('YYYY年MM月DD日') }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					办理店铺:{{customer.ShopName }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					会员状态:{{customer.CustomerState ==1?'正常' :(customer.CustomerState ==2? '暂停':'停止' ) }}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">
				<p>
					<input type="text" placeholder="书籍编码|或者扫描书籍二维码" @keypress="searchBook" class="search"
						v-model="searchBookCode" />
					<button type="button" class="button" :disabled="searchBookCode.length<8" @click="getBook()"
						title="点击进行查找">查找书籍</button>
				</p>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>书籍名称</th>
							<td>
								借书详情
							</td>
							<td>
								还书详情
							</td>


						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index) in books">
							<td>{{index+1}}</td>
							<td>
								{{i.BooksName}}
							</td>
							<td>
								<p v-for="y in i.books" class="returnBooks">
									借出编号:
									<span class="red"> {{ y.BooksNumCode}}
									</span><br />
									借出店铺:
									<span class="red">{{y.ShopName}}
									</span><br />
									借出位置:
									<span class="red">{{y.BorrowOutPlace}}
									</span><br />
									借出时间:
									<span class="red">{{y.BorrowDate}}
									</span><br />
									借出时间:
									<span class="red">{{getDay(y.BorrowDate)}}
									</span><br />
								</p>
							</td>
							<td>
								<p v-for="(y,indexBook) in i.books" class="returnBooks">
									还书编号:
									<input type="text" v-model="y.ReturnBooksNumCode" />
									</span><br />
									还书店铺:
									<span
										class="red">{{y.ReturnShopName==""?$store.state.shopName:y.ReturnShopName}}</span><br />
									还书位置:
									<input type="text" v-model="y.ReturnBackPlace" /><br />
									还书备注:
									<input type="text" v-model="y.Remarks" /><br />
									<span v-show="y.ReturnBookDetailID">取消还书:
										<button type="button" class="buttonSamll"
											@click="cancleReturnBook(index,indexBook)"> 取消还书</button></span>
								</p>
							</td>


						</tr>

					</tbody>
				</table>

			</div>

		</div>
		<p style="text-align: right; color:  red;font-size: 1.3rem;line-height: 2rem;">
			<label>费用:<input type="text" style="width: 2rem;" v-model="payMoney" /></label>
			<label>支付:<select v-model="payType" style="vertical-align: middle;width: 3rem;">
					<option value="1">押金</option>
					<option value="2">其他</option>
				</select></label>
			<br />
			{{'合计:'+returnCount+'本'}}
			<button class="button" @click="returnBooks" :class="{'disabled':!checkReturn || returnCount==0}"
				:disabled="!checkReturn || returnCount==0">提交</button>
		</p>
	</div>

</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
